import axios from "axios";
import { type Entity } from "../../../types/model/entity/Entity";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/entities`;

export const setEntityPrimaryResponsible = async (
  entityId: number,
  responsibleId: number,
): Promise<Entity> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.put(
    `${BASE_URL}/${entityId}/responsibles/${responsibleId}/set-primary`,
    {},
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
